import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import DefaultPage from './DefaultPage';
import WinePage from './WinePage';
import { HelmetProvider } from 'react-helmet-async';

function BlogRedirect() {
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === "/blog") {
            window.location.href = 'https://winetodish.com/blog/index.html';
        }
    }, [location]);

    return null; // Render nothing while redirecting
}

function App() {
    const [isImageLoaded, setIsImageLoaded] = useState(false);

    useEffect(() => {
        const img = new Image();
        img.src = 'assets/amy-chen-LffQyvibxUs-unsplash.jpg'; // Path to the background image
        img.onload = () => setIsImageLoaded(true);
    }, []);

//    if (!isImageLoaded) {
//        return <div className="loading-spinner">Loading...</div>; // Placeholder while loading
//    }

    return (
        <HelmetProvider>
            <div className="app">
                <Router>
                    <Routes>
                        <Route path="/" element={<DefaultPage />} />
                        <Route path="/dish/:dishname" element={<WinePage />} />
                        <Route path="/blog" element={<BlogRedirect />} />
                        <Route path="*" element={<DefaultPage />} />
                    </Routes>
                </Router>
            </div>
        </HelmetProvider>
    );
}

export default App;
